import styles from './LK.module.css'
import LeftSideMenu from "../LeftSideMenu/LeftSideMenu";
import {BrowserRouter, Route, Routes, useLocation} from "react-router-dom";
import React, {useEffect} from "react";
import NewSimParty from "./NewSimParty/NewSimParty";
import ScanRemains from "./ScanRemains/ScanRemains";
import ActiveSimInfo from "./ActiveSimInfo/ActiveSimInfo";
import ActiveSimJob from "./ActiveSimJob/ActiveSimJob";
import LoadNewDkp from "./LoadNewDkp/LoadNewDkp";
import BaseTarifBuilder from "./TarifBuilder/BaseTarifBuilder";
import RefTarifTag from "./RefTarifTag/RefTarifTag";
import SysOption from "./SysOption/SysOption";
import ActivateExcel from "./ActivateExcel/ActivateExcel";
import GeoZoneLoad from "./GeoZoneLoad/GeoZoneLoad";
import ClientOrderList from "../ClientLK/OrderList/ClientOrderList";
import ClientContact from "../ClientLK/ClientContact/ClientContact";
import PassChange from "../ClientLK/PassChange/PassChange";
import PDRemove from "../ClientLK/PDRemove/PDRemove";
import Appeal from "./Appeal/Appeal";
import ClientAppeal from "../ClientLK/ClientAppeal/ClientAppeal";
import TemplateActivate from "../ClientLK/TemplateActivate/TemplateActivate";
import OrderEngine from "./OrderEngine/OrderEngine";
import DashBoard from "./DashBoard/DashBoard";
import CouponItem from "./CouponItem/CouponItem";
import DocBeeline from "./DocCreate/DocBeeline";
import MnpListItem from "./MnpListItem/MnpListItem";
import DocYota from "./DocCreate/DocYota";
import BiometricClient from "./Biometric/BiometricClient/BiometricClient";
import SimStorage from "./SimStorage/SimStorage";
import BiometricWorker from "./Biometric/BiometricWorker/BiometricWorker";
import AtcWorkTime from "./AtcWorkTime/AtcWorkTime";
import ChoiceBot from "../ChoiceBot/ChoiceBot";
import BeelineOrderList from "../BeelineLK/OrderList/BeelineOrderList";
export default function Lk()
{

    return(
        <div>
            <LeftSideMenu>
                <Routes>
                    <Route path='/app/scan' element={<ScanRemains/>} />
                    <Route path='/load' element={<SimStorage></SimStorage>} />
                    <Route path='/app/sim/info' element={<ActiveSimInfo></ActiveSimInfo>} />
                    <Route path='/app/sim/job' element={<ActiveSimJob></ActiveSimJob>} />
                    <Route path='/dkp/load' element={<LoadNewDkp></LoadNewDkp>} />
                    <Route path='/tarif/base' element={<BaseTarifBuilder></BaseTarifBuilder>} />
                    <Route path='/tarif/tag' element={<RefTarifTag></RefTarifTag>} />
                    <Route path='/option' element={<SysOption></SysOption>} />
                    <Route path='/activate/excel' element={<ActivateExcel></ActivateExcel>} />
                    <Route path='/geo/load' element={<GeoZoneLoad></GeoZoneLoad>} />
                    <Route path='/appeal' element={<Appeal></Appeal>} />
                    <Route path='/order/*' element={<OrderEngine></OrderEngine>} />
                    <Route path='/dashboard' element={<DashBoard></DashBoard>} />
                    <Route path='/coupon' element={<CouponItem></CouponItem>} />
                    <Route path='/doc/beeline' element={<DocBeeline></DocBeeline>} />
                    <Route path='/doc/yota' element={<DocYota></DocYota>} />
                    <Route path='/mnp/list' element={<MnpListItem/>} />





                    <Route path='/atc/worktime' element={<AtcWorkTime/>} />

                    <Route path='/client/order/list' element={<ClientOrderList></ClientOrderList>} />
                    <Route path='/client/contact' element={<ClientContact></ClientContact>} />
                    <Route path='/client/pass/change' element={<PassChange></PassChange>} />
                    <Route path='/client/pd/remove' element={<PDRemove></PDRemove>} />
                    <Route path='/client/order/appeal' element={<ClientAppeal></ClientAppeal>} />

                    <Route path='/client/act/template' element={<TemplateActivate></TemplateActivate>} />

                    <Route path='/bio/client/new' element={<BiometricWorker></BiometricWorker>} />
                    <Route path='/bio/client' element={<BiometricClient></BiometricClient>} />

                    <Route path='/beeline/order/list' element={<BeelineOrderList></BeelineOrderList>} />


                </Routes>
            </LeftSideMenu>
        </div>
    );
}